<div class="onboarding-container">
  <div class="onboarding-header">
    <img src="assets/custom/image/AppLogo.png" class="onboarding-logo" alt="" />
  </div>
  <!-- Swiper -->
  <div class="onboarding-content">
    <swiper *ngIf="type == 'component' && show" class="swiper-container" [config]="config">
      <ng-container *ngFor="let step of onBoardingStepTemplateList">
        <ng-container *ngTemplateOutlet="step"></ng-container>
      </ng-container>
    </swiper>
    <!-- <div class="swiper-scrollbar" [hidden]="config.scrollbar === false"></div> -->
    <div class="swiper-pagination" [hidden]="config.pagination === false"></div>
    <!-- <div class="swiper-button-prev" [hidden]="config.navigation === false"></div> -->
    <!-- <div class="swiper-button-next" [hidden]="config.navigation === false"></div> -->
  </div>
  <div class="onboarding-footer">
    <span class="mat-typography">
      Ich bin registriert<a routerLink="/login" color="primary" (click)="setLoginResolver()" mat-button
        href="#">Anmelden</a>
    </span>
  </div>
  <div class="onboarding-bottom-nav">
    <button (click)="navigateToHome()" mat-stroked-button color="primary">Mach ich später...</button>
  </div>
</div>
<ng-template #onBoardingGreeting>
  <div class="swiper-slide">
    <div fxLayout="column" fxLayoutAlign="center center" class="mat-body" fxFlexFill>
      <h3 class="mat-h3">
        {{onBoardingStepDetail.StepDetailName.title}}
      </h3>
      <p class="slider-detail-content">
        {{onBoardingStepDetail.StepDetailName.description}}
      </p>
      <div>
        <mat-form-field>
          <input a11y_Input matInput #firstName placeholder="Vornamen" value=""
            (keyup.enter)="hideKeyboardOnEnter(firstName)" (blur)="setWebView()">
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #onBoardingPostalCode>
  <div class="swiper-slide">
    <div fxLayout="column" fxLayoutAlign="center start" class="mat-body" fxFlexFill>
      <h3 class="mat-h3">
        {{onBoardingStepDetail.StepDetailPostal.title}}
      </h3>
      <p class="slider-detail-content">
        {{onBoardingStepDetail.StepDetailPostal.description}}
      </p>
      <div>
        <mat-form-field>
          <input a11y_Input #postalcode matInput placeholder="Postalcode" value=""
            (keyup.enter)="hideKeyboardOnEnter(postalcode)" (blur)="setWebView()">
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #onBoardingGender>
  <div class="swiper-slide mat-body">
    <div fxLayout="column" fxLayoutAlign="center center" class="mat-body" fxFlexFill>
      <h3 class="mat-h3">
        {{onBoardingStepDetail.StepDetailGender.title}}
      </h3>
      <div>
        <mat-form-field>
          <mat-select placeholder="Geschlecht" [(ngModel)]="selectedGenderValue" name="gender">
            <mat-option *ngFor="let gender of genders" [value]="gender.id">
              {{gender.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #onBoardingBirthdate>
  <div class="swiper-slide">
    <div fxLayout="column" fxLayoutAlign="center center" class="mat-body" fxFlexFill>
      <h3 class="mat-h3">
        {{onBoardingStepDetail.StepDetailBirthday.title}}
      </h3>
      <div>
        <mat-form-field class="example-full-width">
          <input a11y_SpinButton matInput [matDatepicker]="picker" placeholder="Choose a date" (blur)="setWebView()">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #onBoardingAllergy>
  <div class="swiper-slide" style="overflow: unset;">
    <div class="mat-body allergy-container">
      <div class="allergy-content">
        <div>
          <h3 class="mat-h3">
            {{onBoardingStepDetail.StepDetailAllergy.title}}
          </h3>
        </div>
        <div>
          <p class="slider-detail-content">
            {{onBoardingStepDetail.StepDetailAllergy.description}}
          </p>
        </div>
        <div class="chipsListContainer">
          <div class="chipsGroup">
            <mat-chip-list [selectable]="true" [multiple]="true">
              <mat-chip *ngFor="let allergy of allergies" [selected]="allergy.selected" [selectable]="true"
                (click)="allergy.selected=!allergy.selected">{{allergy.name}}</mat-chip>
            </mat-chip-list>
          </div>
          <mat-divider></mat-divider>
          <div class="chipsGroup">
            <mat-chip-list [selectable]="true" [multiple]="true">
              <mat-chip *ngFor="let additive of additives" [selected]="additive.selected" [selectable]="true"
                (click)="additive.selected=!additive.selected">{{additive.name}}</mat-chip>
            </mat-chip-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #onBoardingPreference>
  <div class="swiper-slide">
    <div fxLayout="column" fxLayoutAlign="center center" class="mat-body" fxFlexFill>
      <div>
        <h3 class="mat-h3">
          {{onBoardingStepDetail.StepDetailPrefences.title}}
        </h3>
      </div>
      <div>
        <p class="slider-detail-content">
          {{onBoardingStepDetail.StepDetailPrefences.description}}
        </p>
      </div>
      <div class="chipsListContainer">
        <div class="chipsGroup">
          <mat-chip-list [selectable]="true" [multiple]="true">
            <mat-chip *ngFor="let preference of preferences" [selected]="preference.selected" [selectable]="true"
              (click)="preference.selected=!preference.selected" (selectionChange)="test()">{{preference.name}}
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
    </div>
  </div>
</ng-template>